import React from 'react'
import './Punch.css'

// Images:
// https://www.shareicon.net/gestures-clap-hands-745010
// https://www.shareicon.net/music-and-multimedia-chimes-817261
// https://www.shareicon.net/turn-rotation-twirl-spin-twist-turnabout-turning-revolution-roll-swing-78090
// https://www.shareicon.net/music-cymbals-musical-instrument-drums-cymbal-percussion-instrument-orchestra-music-and-multimedia-817259
const Punch = ({id, name, icon, handlePunch}) => {
  return (
    <img
      className={'punchButton punch' + id}
      src={icon}
      alt={name}
      onClick={() => handlePunch(name)}
    />
  )
}

export default Punch


// WEBPACK FOOTER //
// ./src/Punch/Punch.js